import Toast from './index.vue'

export default {
  install (Vue, options = {}) {
    const property = options.property || '$toast'
    const instance = new Vue(Toast)
    document.body.appendChild(instance.$mount().$el)
    const toast = {
      show (text) {
        instance.text = text
        instance.show()
      }
    }
    Vue.prototype[property] = toast
  }
}



// WEBPACK FOOTER //
// ./src/modules/christmasPC-2019/components/toast/toast.js